// Helper function to get the active/upcoming session
// Checks sessions in order: first session, if time over then second, and so on
export const getActiveSession = (workshopSessions: any[]) => {
  if (!workshopSessions || workshopSessions.length === 0) return null;

  const now = Date.now();

  // Iterate through sessions in order (first, second, third, etc.)
  // Return the first session whose end time hasn't passed yet
  for (const session of workshopSessions) {
    const endTime = new Date(session.endDateTime).getTime();
    if (endTime > now) {
      return session; // Found first session that hasn't ended
    }
  }

  // Fallback: if all sessions have ended, return the last one
  return workshopSessions[workshopSessions.length - 1] || null;
};

// Simple QR code utilities
export const generateQRData = (attendee: any, eventData: any, attendeeId?: number) => {
  const { firstName, lastName, username, profilePicUrl, id: userId } = attendee;
  const ticketId = eventData?.id;
  // Use the same session selection logic as NextSessionInfo
  const activeSession = getActiveSession(eventData?.workshopSessions || []);
  const workshopId = activeSession?.id || eventData?.workshopSessions?.[0]?.id;
  
  const childId = attendee?.childId;
  const finalAttendeeId = attendeeId;
  
  // Debug console logs
  // console.log("=== QR Data Generation Debug ===");
  // console.log("attendee:", attendee);
  // console.log("eventData:", eventData);
  // console.log("firstName:", firstName);
  // console.log("lastName:", lastName);
  // console.log("username:", username);
  // console.log("userId:", userId);
  // console.log("ticketId:", ticketId);
  // console.log("workshopId:", workshopId);
  // console.log("childId:", childId);
  // console.log("attendeeId:", finalAttendeeId);
  // console.log("profilePicUrl:", profilePicUrl);
  
  const qrString = `${firstName} ${lastName}_${username}_${profilePicUrl?.fileDownloadUri || ''}_${ticketId}_${finalAttendeeId}_${userId}_${workshopId}`;
//   console.log("Generated QR String:", qrString);
//   console.log("=== End Debug ===");
  
  return qrString;
};

export const parseQRData = (rawValue: string) => {
  const parts = rawValue.split('_');
  return parts.length >= 7 ? {
    userName: parts[0],
    userHandle: `@${parts[1]}`,
    userProfile: parts[2],
    ticketId: parts[3],
    attendeeId: parts[4],
    userId: parts[5],
    workShopId: parts[6]
  } : null;
};
